module.exports = __webpack_public_path__ + "static/img/11.ee5fde9.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/10/sp/11.png
// module id = MKKf
// module chunks = 0